<template>
    <v-main class="mt-n13">
        <div class="mx-1 mt-1 d-flex d-sm-none d-md-none d-lg-none d-xl-none">
            <v-container fluid>
                <ClientOrderRows v-if="mobileFlag" :load="loadFlag"></ClientOrderRows>
            </v-container>
        </div>
        <div class="d-none d-sm-flex">
        <v-container cols="12" class="px-16 mb-n7" fluid>

            <v-row class="mb-7">
                <v-col cols="12" class="pa-0">
                    <ClientOrderRows v-if="pcFlag" :load="loadFlag"></ClientOrderRows>
                </v-col>
            </v-row>

            <v-container class="mt-15"></v-container>
        </v-container>
        </div>
        <v-row
                align="center"
                justify="center"
                v-if="!loadFlag"
        >
            <v-col
                    cols="12"
                    sm="8"
                    md="4"
            >
                <v-card class="elevation-12">
                    <v-toolbar
                            color="primary"
                            dark
                            flat
                    >
                        <v-img
                                alt="Logo"
                                class="shrink mr-2"
                                contain
                                src="@/assets/logo.svg"
                                transition="scale-transition"
                                width="25"
                        />
                        <v-toolbar-title>{{ this.groupSetting.groupName }} 주문 확인</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon>mdi-login</v-icon>
                    </v-toolbar>
                    <v-card-text class="text-center">
                        <br />
                        <h2>정상적인 접근이 아닙니다.
                            <br /><br />
                            관리자에게 문의하세요.</h2>
                        <br />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-main>
</template>

<script>
import ClientOrderRows from '@/components/client/ClientOrderRows'

export default {
    name: 'ClientDashboard',
    components: {
        ClientOrderRows,
    },
    data() {
        return {
            loadFlag: true,
            mobileFlag: false,
            pcFlag: false,
            groupSetting : null
        }
    },
    methods: {
    },
    beforeCreate: function() {

        if(location.hash == "#/client/dashboard" || location.hash == "#/client/dashboard/"){
            this.$router.push('/client/login')
            return false
        }

        const clientInfo = this.$store.getters.getClientInfo
        if(!clientInfo.clientName && this.$route.params.clientCode){
            this.$router.push('/client/login/' + this.$route.params.clientCode)
            return false
        }

    },
    created() {
        if(location.hash == "#/client/dashboard" || location.hash == "#/client/dashboard/"){
            this.load = false
        }

        switch(this.$vuetify.breakpoint.name) {
            case 'xl':
            case 'lg':
            case 'md':
            case 'sm':
                this.mobileFlag = false
                this.pcFlag = true
                break
            case 'xs':
                this.mobileFlag = true
                this.pcFlag = false
                break
        }

        if(this.$store.getters.getGroupSetting != null){
            this.groupSetting = this.$store.getters.getGroupSetting
        }
    }
}
</script>